import mapboxgl from 'mapbox-gl';

export const zoomToMultiplePolygons = (geometries: any[], mapRef: any, isAll= false) => {
  setTimeout(() => {
    const zoom = mapRef?.getZoom() ?? 12;
    // if (zoom > 13 && !isAll) {
    //   return;
    // }
    if (mapRef) {
      const bounds = new mapboxgl.LngLatBounds(
        geometries[0].coords[0][0],
        geometries[0].coords[0][0]
      );

      geometries.forEach(geometry => {
        geometry.coords[0].forEach((coord: [number, number]) => {
          bounds.extend(coord);
        });
      });

      mapRef.fitBounds(bounds, {
        padding: { top: 30, bottom: 60, left: 50, right: 50 },
        maxZoom: geometries.length === 1 ? 16: 14,
        duration: 1000
      });
    }
  }, 500);
};

interface LocationData {
  latitude: number;
  longitude: number;
}

export const zoomToMultiplePoints = (
  points: LocationData[],
  mapRef:
    | ({
        getMap(): mapboxgl.Map;
      } & Omit<
        mapboxgl.Map,
        | 'setMaxBounds'
        | 'setMinZoom'
        | 'setMaxZoom'
        | 'setMinPitch'
        | 'setMaxPitch'
        | 'setRenderWorldCopies'
        | 'setProjection'
        | 'setStyle'
        | 'addSource'
        | 'removeSource'
        | 'addLayer'
        | 'removeLayer'
        | 'setLayerZoomRange'
        | 'setFilter'
        | 'setPaintProperty'
        | 'setLayoutProperty'
        | 'setLight'
        | 'setTerrain'
        | 'setFog'
        | 'remove'
      >)
    | undefined
) => {
  setTimeout(() => {
    if (mapRef && points.length > 0) {
      const bounds = new mapboxgl.LngLatBounds(
        [points[0].longitude, points[0].latitude],
        [points[0].longitude, points[0].latitude]
      );
      points.forEach((point) => {
        bounds.extend([point.longitude, point.latitude]);
      });

      mapRef.fitBounds(bounds, {
        padding: { top: 30, bottom: 60, left: 50, right: 50 },
        maxZoom: 16,
        duration: 1000,
      });
    }
  }, 500);
};
